import React from "react";
import { Form } from "react-bootstrap";
import "./dashboard copy.css";

/**
 * CardFinancing Component
 * 
 * Displays capital financing options on the dashboard with information about
 * merchant cash advances, lines of credit, and other financing solutions.
 * Provides a call-to-action button to apply for financing and navigate to
 * the capital financing application page.
 * 
 * @returns {JSX.Element} Dashboard card with financing information and apply button
 */
const CardFinancing = () => {
  return (
    <>
      <p className="dashboardCardHeader">
        <Form.Select>
          <option>Capital financing for roiquant customers</option>
        </Form.Select>
      </p>

      <hr />

      <p className="dashboardCardData">Fast. Flexible. Transparent.</p>

      <div className="dashboardDivScrollable">
        <p className="dashboardCardText">
          Capital financing to help your business grow, such as merchant cash
          advance, lines of credit, receivables financing, invoice factoring,
          equipment financing, term loans, and SBA loans.
        </p>
      </div>

      <div className="dashboardBottomDiv">
        <div className="dashboardCardButton">
          <a href="/capital-financing">
            <button className="glintanimation navbarideachecker">
              Apply now
            </button>
          </a>
        </div>

        <br />

        <p className="dashboardMinorText">
          Available for US and Canada customers only
        </p>
      </div>
    </>
  );
};

export default CardFinancing;
